// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperContainer-cls1_mf6","cls2":"PaperContainer-cls2__IU PaperContainer-cls1_mf6"};